/* eslint-disable */
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

import {
  CAT_NECESSARY,
  CAT_ANALYTICS,
  CAT_ADVERTISEMENT,
  SERVICE_ANALYTICS_STORAGE,
  SERVICE_AD_STORAGE,
  SERVICE_AD_USER_DATA,
  SERVICE_AD_PERSONALIZATION,
} from "./constants.js";

import {
  am,
  ar,
  ckb,
  en,
  fa,
  ku,
  om,
  pa,
  ps,
  ru,
  so,
  sq,
  ti,
  ur,
  vi,
  amServicesLabel,
  arServicesLabel,
  ckbServicesLabel,
  enServicesLabel,
  faServicesLabel,
  kuServicesLabel,
  omServicesLabel,
  paServicesLabel,
  psServicesLabel,
  ruServicesLabel,
  soServicesLabel,
  sqServicesLabel,
  tiServicesLabel,
  urServicesLabel,
  viServicesLabel,
} from "./translations/index.js";

const translationOptions = {
  am,
  ar,
  ckb,
  en,
  fa,
  ku,
  om,
  pa,
  ps,
  ru,
  so,
  sq,
  ti,
  ur,
  vi,
};

// // Initialize dataLayer and gtag function
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  // Set default consent to 'denied'
  window.gtag("consent", "default", {
    [SERVICE_ANALYTICS_STORAGE]: "denied",
    [SERVICE_AD_STORAGE]: "denied",
    [SERVICE_AD_USER_DATA]: "denied",
    [SERVICE_AD_PERSONALIZATION]: "denied",
    [CAT_NECESSARY]: "granted",
  });
}

export default {
  methods: {
    initCookieConsent: function () {
      CookieConsent.run({
        onFirstConsent: () => {
          this.updateGtagConsent();
        },
        onConsent: () => {
          this.updateGtagConsent();
        },
        onChange: () => {
          this.updateGtagConsent();
        },

        categories: {
          [CAT_NECESSARY]: {
            enabled: true,
            readOnly: true,
          },
          [CAT_ANALYTICS]: {
            autoClear: {
              cookies: [{ name: /^_ga/ }, { name: "_gid" }],
            },
            services: {
              [SERVICE_ANALYTICS_STORAGE]: {
                label: this.getServicesLabel(),
              },
            },
          },
        },
        language: {
          default: this.detectLanguage(),
          translations: translationOptions,
        },
      });
    },
    // Update gtag consent based on user choices
    updateGtagConsent: function () {
      if (typeof window === "undefined") return;

      window.gtag("consent", "update", {
        [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS)
          ? "granted"
          : "denied",
        [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT)
          ? "granted"
          : "denied",
        [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT)
          ? "granted"
          : "denied",
        [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT)
          ? "granted"
          : "denied",
        [CAT_NECESSARY]: "granted",
      });
    },
    getServicesLabel: function () {
      const servicesLabelMap = {
        am: amServicesLabel,
        ar: arServicesLabel,
        ckb: ckbServicesLabel,
        en: enServicesLabel,
        fa: faServicesLabel,
        ku: kuServicesLabel,
        om: omServicesLabel,
        pa: paServicesLabel,
        ps: psServicesLabel,
        ru: ruServicesLabel,
        so: soServicesLabel,
        sq: sqServicesLabel,
        ti: tiServicesLabel,
        ur: urServicesLabel,
        vi: viServicesLabel,
      };

      const lang = this.detectLanguage();
      return servicesLabelMap[lang] || enServicesLabel;
    },
    detectLanguage: function () {
      let currentLang = localStorage.getItem("current_lang");

      // if current lang is set and translation is available
      if (currentLang !== null && translationOptions[currentLang]) {
        return currentLang;
      }

      // default to english
      return "en";
    },
  },
};
/* eslint-enable */
